<script setup>
  import { ref, computed, defineAsyncComponent, onMounted } from 'vue'

  import { useAlertStore } from '@/stores/AlertStore';
  import { useGoogleMapsStore } from '@/stores/GoogleMapsStore';

  import { useMediaQuery } from '@/composables/useMediaQuery';
  
  import CompleteReportDataContainerSection from '@/components/CompleteReportDataContainerSection.vue';
  import DataContainer from './DataContainer.vue';
  
  import useSpotGlobals from '@/composables/useSpotGlobals';
  
  const { $ADVISORY_ID } = useSpotGlobals();

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const AdvisoriesListing = defineAsyncComponent(() => import('@/components/AdvisoriesListing.vue')); 

  const props = defineProps({
    upgrade: {
      type: Array,
    required: true
    }
  });

  const alertStore = useAlertStore();
  const googleMapsStore = useGoogleMapsStore();

  const content = ref(null);
  const googleMapsLoaded = ref(false);

  const minHeight = computed(() => {
    const baseHeight = isDesktop.value ? 88 : 72;
    const cardHeight = isDesktop.value ? 49.5 : 65.4;
    const totalCardsHeight = alertStore.alertCount * cardHeight;
    const gapHeight = (alertStore.alertCount - 1) * 8;

    return `${baseHeight + totalCardsHeight + gapHeight}px`;
  }); 

  function loadAdvisories() {
    googleMapsLoaded.value = true;
  }

  onMounted(() => {
    googleMapsStore.loadMaps(loadAdvisories);
  })
</script>

<template>
    <CompleteReportDataContainerSection
      v-model:content="content"
      sectionId="advisories"
      title="Advisories"
      :minHeight="minHeight"
      :metaActions="false"
    >
      <template #content="{ isVisible }">
        <DataContainer style="width: 100%; height: 100%;">
          <AdvisoriesListing
            v-if="googleMapsLoaded && isVisible || $ADVISORY_ID"
            v-model:content="content"
            :advisoryId="$ADVISORY_ID"
          />
        </DataContainer>
      </template>
    </CompleteReportDataContainerSection>
</template>